import React from "react";
import { AiFillTags } from "@react-icons/all-files/ai/AiFillTags";
import { useNavigate, useSearchParams } from "react-router-dom";

function Tag({ tag }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const genre = searchParams.get("genre") || "";

  const handleClick = () => {
    if (genre !== tag) {
      navigate(`/?genre=${tag}`);
    }
  };
  return (
    <div
      title={tag}
      onClick={handleClick}
      className="max-h-auto w-full sm:w-fit "
    >
      <div className="Purple-btn-effect relative cursor-pointer">
        <div className="flex justify-start lg:justify-center  items-center text-secondary  h-[52px] bg-tertiary hover:bg-tertiary/90 duration-500 ease-in-out">
          <div className="w-[52px] h-[52px] flex-none bg-primary text-tertiary  flex justify-center items-center">
            <AiFillTags className="text-[16px] md:text-[20px]" />
          </div>
          <span className="flex-1 line-clamp-1 px-[30px] md:px-[50px]  text-secondary capitalize text-[14px] md:text-[15px] font-SoraR">
            {tag}
          </span>
        </div>
      </div>
    </div>
  );
}

export default Tag;
